<template>
  <div v-if="area">
    <div class="alignRight">
      <button @click="closeEditArea()" title="Abbrechen" style="transform: translateY(-9px);" class="btn--icon"><svgicon icon="close" width="32" height="32" color="#000000"></svgicon></button>
   </div>

   <h1 style="margin-bottom: 0px;"><blur-editable :content="area.title" @change="change()" @update="area.title = $event"></blur-editable></h1>
    <!-- <h1>Bereich</h1> -->
    <!-- <p>Hier können Sie den Bereich umbenennen, verschieben, skalieren oder löschen.</p> -->
    <p-check name="check" color="success" @change="change()" v-model="area.internal">Interner Bereich</p-check>
    <button @click="deleteArea()" class="btn--subtile"><svgicon icon="delete" width="32" height="32" color="#000000"></svgicon>Bereich löschen</button><br />
  </div>
</template>

<script>
import BlurEditable from '@/components/BlurEditable' // eslint-disable-line

export default {
  props: ['area'],
  data () {
    return {
      keyBefore: this.area['.key'],
      titleBefore: this.area.title,
      titleSaved: false
    }
  },
  components: {
    BlurEditable
  },
  methods: {
    save: function () {
      if (this.area.title != null) {
        this.$emit('update-area', this.area)
        this.titleSaved = true
        this.closeEditArea()
      }
    },
    change: function () {
      this.$emit('update-area', this.area)
    },
    titleChange: function () {
      this.titleSaved = false
    },
    deleteArea: function () {
      var r = confirm('Sind Sie wirklich sicher diesen Bereich unwiederruflich zu löschen?')
      if (r === true) {
        this.$emit('delete-area', this.area)
        this.closeEditArea()
      }
    },
    closeEditArea: function () {
      this.$emit('edit-area-close')
    },
    reset: function () {
      // if (this.titleSaved === false && this.area['.key'] === this.keyBefore) {
      //   this.area.title = this.titleBefore
      // }
    }
  },
  updated () {
    this.titleSaved = false
    this.titleBefore = this.area.title
    this.keyBefore = this.area['.key']
  },
  beforeDestroy () {
    this.reset()
  },
  beforeUpdate () {
    this.reset()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditArea.vue